import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import GithubSecretScanConfigListing from './GithubSecretScanConfigListing';
import GithubSecretScanCredentialsForm from './GithubSecretScanCredentialsForm';

const GithubSecretScanPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={GithubSecretScanCredentialsForm}
        PullConfigListingView={GithubSecretScanConfigListing}
     />
);

export default GithubSecretScanPullAndPushView;
